module.exports = __webpack_public_path__ + "assets/81e352a38ad33f64ab5619ace52a4c14.png";